function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67ADB6",
  fillRule: "evenodd",
  d: "M55.218 7.711c.863 1.704 1.357 3.594 1.357 5.528 0 19.158-20.257 28.182-25.331 28.182-.376 0-.376-1.483 0-2.225 2.672-1.453 10.554-6.634 10.876-15.043-5.485-1.045-9.632-5.866-9.632-11.656 0-6.553 5.313-11.866 11.867-11.866 4.851 0 9.022 2.91 10.863 7.08zm-30.356 0c.864 1.704 1.357 3.594 1.357 5.528 0 19.158-20.256 28.182-25.33 28.182-.376 0-.376-1.483 0-2.225 2.671-1.453 10.554-6.634 10.876-15.043-5.486-1.045-9.632-5.866-9.632-11.656C2.133 5.944 7.446.631 14 .631c4.85 0 9.022 2.91 10.862 7.08z"
});

var SvgRoundQuotesEnd = function SvgRoundQuotesEnd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 57,
    height: 42,
    viewBox: "0 0 57 42",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRoundQuotesEnd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/round-quotes-end.48025ad8.svg";
export { ForwardRef as ReactComponent };